/**
 * 复制文本到剪贴板
 *
 * 接口返回的链接是异步拿到的，点击的瞬间才产生文本，
 * 所以不能用 clipboard.js 「先绑定元素、后触发」的方式，
 * 这里直接写入剪贴板：优先 navigator.clipboard，失败再降级到 execCommand。
 *
 * @param text 要复制的文本
 * @returns 是否复制成功
 */
export const copyText = async (text: string): Promise<boolean> => {
  if (!text) return false;

  if (navigator.clipboard && window.isSecureContext) {
    try {
      await navigator.clipboard.writeText(text);
      return true;
    } catch (e) {
      // 浏览器拒绝（无权限等），继续走降级方案
    }
  }

  const textarea = document.createElement("textarea");
  textarea.value = text;
  // 固定定位 + 透明，避免复制时页面滚动或出现闪烁的输入框
  textarea.style.position = "fixed";
  textarea.style.top = "-9999px";
  textarea.style.opacity = "0";
  textarea.setAttribute("readonly", "");
  document.body.appendChild(textarea);

  let success = false;
  try {
    textarea.select();
    success = document.execCommand("copy");
  } catch (e) {
    success = false;
  }
  document.body.removeChild(textarea);

  return success;
};
